import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/views/layout/Layout.vue'),
    name: 'Layout',
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/layout/Dashboard.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'products',
        name: 'ProductList',
        component: () => import('@/views/product/ProductList.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'products/add',
        name: 'ProductAdd',
        component: () => import('@/views/product/ProductForm.vue'),
        meta: { title: '商品发布' }
      },
      {
        path: 'products/edit/:id',
        name: 'ProductEdit',
        component: () => import('@/views/product/ProductForm.vue'),
        meta: { title: '商品编辑' }
      },
      {
        path: 'merchants',
        name: 'MerchantList',
        component: () => import('@/views/merchant/MerchantList.vue'),
        meta: { title: '商户管理' }
      },
      {
        path: 'orders',
        name: 'OrderList',
        component: () => import('@/views/order/OrderList.vue'),
        meta: { title: '订单管理', roles: [1] }
      },
      {
        path: 'merchant/orders',
        name: 'MerchantOrderList',
        component: () => import('@/views/order/MerchantOrderList.vue'),
        meta: { title: '我的订单', roles: [2] }
      },
      {
        path: 'users',
        name: 'UserList',
        component: () => import('@/views/user/UserList.vue'),
        meta: { title: '用户管理', roles: [1] }
      },
      {
        path: 'categories',
        name: 'CategoryList',
        component: () => import('@/views/category/CategoryList.vue'),
        meta: { title: '分类管理', roles: [1] }
      },
      {
        path: 'roles',
        name: 'RoleList',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理', roles: [1] }
      },
      {
        path: 'menus',
        name: 'MenuList',
        component: () => import('@/views/system/menu/index.vue'),
        meta: { title: '菜单管理', roles: [1] }
      },
      {
        path: 'login-logs',
        name: 'LoginLog',
        component: () => import('@/views/system/log/login.vue'),
        meta: { title: '登录日志', roles: [1] }
      },
      {
        path: 'operation-logs',
        name: 'OperationLog',
        component: () => import('@/views/system/log/operation.vue'),
        meta: { title: '操作日志', roles: [1] }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/user/Profile.vue'),
        meta: { title: '个人中心', roles: [1, 2] }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = store?.state?.token
    if (!token) {
      next('/login')
    } else {
      if (!store?.state?.dynamicRoutesLoaded) {
        await store.dispatch('loadDynamicRoutes')
      }
      if (!store?.state?.userInfo) {
        try {
          await store.dispatch('getUserInfo')
        } catch (error) {
          next('/login')
          return
        }
      }

      const userRole = store?.state?.userInfo?.role

      // 商家(role=2)只能访问商品页面和个人中心
      if (userRole === 2) {
        const allowedRoutes = ['/dashboard', '/products', '/products/add', '/products/edit', '/profile', '/merchant/orders']
        if (!allowedRoutes.includes(to.path) && !to.path.startsWith('/products/edit')) {
          next('/dashboard')
          return
        }
      }

      // 管理员-only页面权限控制
      if (to.meta.roles && !to.meta.roles.includes(userRole)) {
        next('/dashboard')
        return
      }

      next()
    }
  } else {
    next()
  }
})

export default router
